function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.1537 16.7988L16.7227 31.0648H20.6107L23.0437 16.7988H19.1537Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4613 16.815L9.65333 26.544L9.24733 25.075C8.49633 23.305 6.36433 20.763 3.86133 19.161L7.34333 31.058L11.4573 31.051L17.5803 16.812L13.4613 16.815Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.772 17.8358C7.546 16.9668 6.891 16.7078 6.078 16.6768H0.05L0 16.9608C4.691 18.0988 7.795 20.8408 9.083 24.1378L7.772 17.8358Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.923 19.5342C32.195 19.5142 33.117 19.7922 33.833 20.0802L34.184 20.2452L34.71 17.1532C33.94 16.8642 32.733 16.5542 31.227 16.5542C27.385 16.5542 24.677 18.4892 24.656 21.2622C24.631 23.3112 26.585 24.4552 28.061 25.1382C29.576 25.8382 30.084 26.2832 30.077 26.9082C30.065 27.8632 28.869 28.3012 27.752 28.3012C26.195 28.3012 25.368 28.0862 24.091 27.5542L23.59 27.3262L23.043 30.5192C23.953 30.9182 25.632 31.2612 27.375 31.2792C31.462 31.2792 34.118 29.3672 34.146 26.4042C34.163 24.7832 33.126 23.5462 30.879 22.5312C29.519 21.8692 28.687 21.4292 28.695 20.7612C28.695 20.1682 29.401 19.5342 30.923 19.5342Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.687 16.8149H41.683C40.75 16.8149 40.056 17.0689 39.646 17.9989L33.873 31.0729H37.956C37.956 31.0729 38.622 29.3149 38.773 28.9299C39.22 28.9299 43.187 28.9359 43.752 28.9359C43.868 29.4339 44.226 31.0729 44.226 31.0729H47.833L44.687 16.8149ZM39.892 26.0099C40.212 25.1909 41.441 22.0229 41.441 22.0229C41.42 22.0619 41.758 21.1979 41.959 20.6609L42.221 21.8909C42.221 21.8909 42.966 25.2969 43.122 26.0099H39.892Z",
  fill: "white"
}));

var SvgVisa = function SvgVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa.27356aed.svg";
export { ForwardRef as ReactComponent };